import { useParams } from 'react-router-dom';
import axios from 'axios';
import config from '../config';
import { useEffect, useState } from 'react';
import ClassesLayout from '../components/organisms/ClassesLayout';

const Classes = () => {
  const { levelSelection } = useParams();
  const [sessions, setSessions] = useState([]);
  const [levelSpread, setLevelSpread] = useState([]);
  const [sessionSpread, setSessionSpread] = useState([]);
  const [students, setstudents] = useState();
  const [moveStudentOpen, setmoveStudentOpen] = useState(false);
  const [sacramentOpen, setSacramentOpen] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState();
  const [remoteTrigger, setRemoteTrigger] = useState(0);
  const [pageMsg, setPageMsg] = useState('Please select a level to proceed');
  const [sacramentType, setSacramentType] = useState('');
  const [snackBarOpen, setSnackBarOpen] = useState(false);

  let level = 0;
  let pageLevelTitle;

  if (levelSelection !== undefined) {
    const getLevel = Number(levelSelection.replace(/[level//-]/gi, ''));
    level = getLevel;
    const levelCount = levelSpread[level - 1];

    pageLevelTitle = 'Level ' + getLevel + ' (' + levelCount?.count + ')';
  } else {
    level = 0;
    pageLevelTitle = '';
  }

  useEffect(() => {
    // get session spread info
    const classData = new FormData();
    classData.append('mode', 'sessionAndSpread');
    classData.append('auth', localStorage.getItem('token'));

    axios
      .post(config.SESSION_API, classData)
      .then(output => {
        setSessions(output.data.response.sessions);
        setLevelSpread(output.data.response.studentSpread);
      })
      .catch(error => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    // get student / class info
    setstudents();
    if (!Number.isInteger(level) || level === 0) return;

    const levelQuery = new FormData();
    levelQuery.append('function', 'getStudentFromLevel');
    levelQuery.append('level', level);
    levelQuery.append('auth', localStorage.getItem('token'));

    axios
      .post(config.API, levelQuery)
      .then(output => {
        if (output.data.response === 'NO_STUDENTS') {
          setPageMsg('No students enrolled in this level.');
        } else {
          setstudents(output.data.response.students);
          setSessionSpread(output.data.response.sessionCount);
        }
      })
      .catch(error => {
        console.error(error);
      });
  }, [level, remoteTrigger]);

  // MOVE STUDENT DIALOG
  const openMoveStudentDialog = student => {
    setSelectedStudent(student);
    setmoveStudentOpen(true);
  };
  const closeMoveStudentDialog = value => {
    setmoveStudentOpen(false);
  };
  //-- END MOVE STUDENT DIALOG

  // SACRAMENTS CONFIRMATION DIALOG
  const openSacramentDialog = () => {
    setSacramentOpen(true);
  };
  const closeSacramentDialog = () => {
    setSacramentOpen(false);
    setSacramentType('');
  };
  const updateSacraments = () => {
    if (sacramentType !== '') {
      const sacramentData = new FormData();
      sacramentData.append('auth', localStorage.getItem('token'));
      sacramentData.append('mode', 'updateSacrament');
      sacramentData.append('type', sacramentType);
      sacramentData.append('level', levelSelection);

      axios.post(config.STUDENTS_API, sacramentData).then(output => {
        if (output.data.response.status === 'OK') {
          setSnackBarOpen(true);
          setSacramentOpen(false);
        }
      });
    }
  };
  //-- END SACRAMENTS CONFIRMATION DIALOG

  // SNACKBAR
  const snackBarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackBarOpen(false);
  };
  // END SNACKBAR

  if (sessions?.length === 0) return <div>Loading...</div>;

  return (
    <ClassesLayout
      pageLevelTitle={pageLevelTitle}
      pageMsg={pageMsg}
      sessions={sessions}
      students={students}
      sessionSpread={sessionSpread}
      openMoveStudentDialog={openMoveStudentDialog}
      closeMoveStudentDialog={closeMoveStudentDialog}
      openSacramentDialog={openSacramentDialog}
      closeSacramentDialog={closeSacramentDialog}
      selectedStudent={selectedStudent}
      moveStudentOpen={moveStudentOpen}
      sacramentOpen={sacramentOpen}
      setRemoteTrigger={setRemoteTrigger}
      levelSelection={levelSelection}
      setSacramentType={setSacramentType}
      sacramentType={sacramentType}
      updateSacraments={updateSacraments}
      snackBarOpen={snackBarOpen}
      snackBarClose={snackBarClose}
    />
  );
};

export default Classes;
